import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
}));

export default function SalesDetailsTable(props) {
  const { data, isPurches } = props;

  const stylH = {
    // borderWidth: 1,
    border: "solid 0.6px",
    borderColor: "black",
    borderStyle: "solid",
    fontFamily: "Amiri-Regular",
    fontWeight: 700,
    fontSize: 15,
    color: "#fff"
}
const stylRo = {
    BorderBottom: "solid 0.5px",
    //borderStyle: "solid",
    borderColor: "gray",
    fontFamily: "Amiri-Regular",
    fontWeight: 700,
    fontSize: 14,
    color: "#000"
}

  
  const { t } = useTranslation(["forms"]);
  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            style={{
              backgroundColor:isPurches?colors.blue[300]:colors.green[300],
              color: "#fff",
            }}
          >
            <TableCell style={{ color: "#fff" ,fontWeight:"bold"}} align="center">
              {"الصنف"}
            </TableCell>
            <TableCell style={{ color: "#fff",fontWeight:"bold" }} align="center">
              {"الكمية"}
            </TableCell>
            <TableCell style={{ color: "#fff",fontWeight:"bold" }} align="center">
              {"السعر"}
            </TableCell>
            <TableCell style={{ color: "#fff",fontWeight:"bold" }} align="center">
              {"الخصم"}
            </TableCell>
            <TableCell style={{ color: "#fff",fontWeight:"bold" }} align="center">
              {"الضريبة"}
            </TableCell>
            <TableCell style={{ color: "#fff" ,fontWeight:"bold"}} align="center">
              {"الصافي مع الضريبة"}
            </TableCell>
            <TableCell style={{ color: "#fff" ,fontWeight:"bold"}} align="center">
              {isPurches?"المورد":"العميل"}
            </TableCell>
            <TableCell style={{ color: "#fff",fontWeight:"bold" }} align="center">
              {"التفاصيل"}
            </TableCell>
            <TableCell style={{ color: "#fff",fontWeight:"bold" }} align="center">
                {"طريقة الدفع"}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.val1}>
              <TableCell style={stylRo} align="center">{row.symbol}</TableCell>
              <TableCell style={stylRo}  align="center">{row.val1}</TableCell>
              <TableCell style={stylRo}  align="center">{row.exchange_price?.toFixed(2)}</TableCell>
              <TableCell style={stylRo}  align="center">{row.discount?.toFixed(2)}</TableCell>
              <TableCell style={stylRo}  align="center">{row.taxval?.toFixed(2)}</TableCell>
              <TableCell style={stylRo}  align="center">{row.amount?.toFixed(2)}</TableCell>
              <TableCell style={stylRo}  align="center">{row.customer_name}</TableCell>
              <TableCell style={stylRo}  align="center">{row.trans_name_ar}</TableCell>
              <TableCell style={stylRo}  align="center">{row.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
